<template>
  <div class="container-fluid mt-4" dir="rtl">
    
    <!-- 1. الفلاتر (لا تظهر في الطباعة) -->
    <div class="card shadow-sm mb-4 border-top-dark no-print">
      <div class="card-header bg-white py-3">
        <h5 class="mb-0 fw-bold">
          <i class="fas fa-sort-amount-down ms-2"></i> المجموع التكراري (ترتيب المجاميع)
        </h5>
      </div>
      <div class="card-body">
        <div class="row g-3 align-items-end">
          <div class="col-md-4">
            <label class="form-label fw-bold">القطاع</label>
            <select v-model="filters.sector" class="form-select">
              <option value="">-- كل المحافظة --</option>
              <option value="1">قطاع العريش</option>
              <option value="2">قطاع بئر العبد</option>
            </select>
          </div>
          <div class="col-md-4">
            <button @click="fetchData" class="btn btn-dark w-100" :disabled="loading">
              <span v-if="loading" class="spinner-border spinner-border-sm ms-2"></span>
              عرض الإحصاء
            </button>
          </div>
          <div class="col-md-4">
             <button @click="printPage" class="btn btn-outline-dark w-100" :disabled="reportData.length === 0">
               <i class="fas fa-print ms-2"></i> طباعة التقرير
             </button>
          </div>
        </div>
      </div>
    </div>

    <!-- 2. التقرير (الطباعة) -->
    <div id="printMe" v-if="reportData.length > 0">
      
      <!-- ترويسة -->
      <div class="text-center mb-4 pt-3 border-bottom pb-3 d-none d-print-block">
         <h3 class="fw-bold text-decoration-underline">بيان المجموع التكراري للدرجات</h3>
         <h5 class="text-muted">الشهادة الإعدادية - الدور الأول 2026</h5>
         <div class="mt-2">
             <span class="badge bg-light text-dark border px-3 fs-6">إجمالي الناجحين: {{ totalStudents }}</span>
         </div>
      </div>

      <!-- جسم التقرير (أعمدة متعددة) -->
      <div class="multi-column-container">
          
          <table class="table table-bordered table-sm text-center align-middle mb-0 data-table">
            <thead class="table-dark">
              <tr>
                <th width="33%">الدرجة</th>
                <th width="33%">العدد</th>
                <th width="33%" class="bg-warning text-dark">التكراري</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="row in reportData" :key="row.degree" :class="{'fw-bold bg-light': row.count > 0}">
                <td class="font-monospace">{{ row.degree }}</td>
                
                <!-- العدد الفعلي -->
                <td>
                    <span v-if="row.count > 0">{{ row.count }}</span>
                    <span v-else class="text-muted opacity-25">-</span>
                </td>
                
                <!-- التكراري -->
                <td class="bg-warning-subtle fw-bold">{{ row.cumulative }}</td>
              </tr>
            </tbody>
          </table>

      </div>

      <!-- تذييل -->
      <div class="mt-4 pt-3 border-top d-none d-print-block break-avoid">
          <div class="d-flex justify-content-around fw-bold text-center">
              <div>
                  <p class="mb-1 text-muted">رئيس لجنة النظام والمراقبة</p>
                  <p>....................</p>
              </div>
              <div>
                  <p class="mb-1 text-muted">مدير المديرية</p>
                  <p>....................</p>
              </div>
          </div>
      </div>

    </div>
  </div>
</template>

<script>
import api from '@/api/axios';

export default {
  name: "CumulativeFrequency",
  data() {
    return {
      loading: false,
      filters: { sector: '' },
      reportData: [],
      totalStudents: 0
    };
  },
  methods: {
    async fetchData() {
      this.loading = true;
      try {
        const res = await api.get('/admin/cumulative-report', { params: this.filters });
        this.reportData = res.data.data;
        this.totalStudents = res.data.total_students;
      } catch (e) {
        alert("حدث خطأ");
      } finally {
        this.loading = false;
      }
    },
    printPage() {
        this.$htmlToPaper("printMe");
    }
  }
};
</script>

<style scoped>
.border-top-dark { border-top: 4px solid #212529; }
.bg-warning-subtle { background-color: #fff3cd !important; }

/* === التنسيق السحري للأعمدة المتعددة === */
.multi-column-container {
    /* يقسم الحاوية إلى أعمدة (مثل الجرائد) */
    column-count: 4; 
    column-gap: 20px;
    column-rule: 1px solid #ccc; /* خط فاصل بين الأعمدة */
    width: 100%;
}

/* تنسيق الجدول داخل الأعمدة */
.data-table {
    width: 100%;
    /* منع الجدول من الانقسام بشكل سيء */
    break-inside: auto; 
}

.data-table thead {
    /* تكرار الهيدر ليس ضرورياً هنا لأن الأعمدة في نفس الصفحة */
    /* display: table-header-group; */
}

/* في الشاشات الصغيرة (موبايل) نلغي الأعمدة */
@media (max-width: 768px) {
    .multi-column-container {
        column-count: 1;
    }
}

/* === تنسيقات الطباعة === */
@media print {
  @page {
    size: A4 portrait;
    margin: 10mm;
  }

  body * { visibility: hidden; }
  .no-print { display: none !important; }
  #printMe, #printMe * { visibility: visible; }
  #printMe { position: absolute; left: 0; top: 0; width: 100%; }

  /* تفعيل الأعمدة في الطباعة */
  .multi-column-container {
      column-count: 4 !important; 
      column-gap: 15px;
  }

  .table-bordered th, .table-bordered td {
      border: 1px solid #000 !important;
      padding: 2px !important;
      font-size: 10pt;
  }

  .bg-warning {
      background-color: #ffc107 !important;
      -webkit-print-color-adjust: exact;
  }
  .bg-warning-subtle {
      background-color: #fff3cd !important;
      -webkit-print-color-adjust: exact;
  }
  .table-dark {
      background-color: #000 !important;
      color: #fff !important;
      -webkit-print-color-adjust: exact;
  }
  
  .break-avoid {
      page-break-inside: avoid;
      column-span: all; /* يجعل التذييل يمتد بعرض الصفحة أسفل الأعمدة */
  }
}
</style>